<template>
  <b-dropdown-item
    class="p-0 notification-btn overflow-hidden"
    href="#"
    @click="onClickNotification"
  >
    <img :src="notificationIcon" alt="" class="mr-4" />
    <div>
      <p class="mb-2" style="white-space: normal">{{ text }}</p>
      <p class="time mb-0 text-gray600">
        {{ $day(notification.createdAt).format('YYYY.MM.DD') }}
      </p>
    </div>
  </b-dropdown-item>
</template>

<script>
import {convertRank} from '@/lib/base/ranking.js';
import notificationIcon from '@/assets/img/icon/notification-icon.png';
import {EVENT_TYPES} from '@/constant/event.js';
export default {
  props: {
    notification: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      notificationIcon,
    };
  },
  computed: {
    text() {
      let text = '';
      switch (this.notification.type) {
        case 'NEW_CERTIFICATION':
          text = `${this.$t('您有一筆可申請的證書')} - ${convertRank(
            this.notification.rank
          )}`;
          break;
        case 'EXAM_RELEASED':
          text = `${this.$t('您的棋力檢定成績已出爐')} - ${convertRank(
            this.notification.rank
          )}`;
          break;
        case 'TOURNAMENT_SCORE_APPROVED':
          text = `${this.$t('您參加的比賽成績已公布')} - ${
            this.notification.eventName
          }`;
          break;
        case 'UPDATE_RANK':
          text = `${this.$t('恭喜！您的棋力已升級至')}${convertRank(
            this.notification.rank
          )}`;
          break;
        case 'EVENT_UPDATE':
          text = `${this.$t('您報名的')}${this.notification.eventName}${this.$t(
            '，主辦單位有調整內容，快來查看!'
          )}`;
          break;
      }

      return text;
    },
    routers() {
      return {
        NEW_CERTIFICATION: {
          name: 'personal',
          query: {
            state: 'certificate',
          },
        },
        EXAM_RELEASED: {
          name: 'personal',
          query: {
            state: 'exam',
          },
        },
        TOURNAMENT_SCORE_APPROVED: {
          name: 'eventInformation',
          params: {
            id: this.notification.eventId,
            pagination: 1,
          },
        },
        UPDATE_RANK: {
          name: 'personal',
          query: {
            state: 'exam',
          },
        },
        EVENT_UPDATE: {
          name:
            this.notification.eventType === EVENT_TYPES.EXAM
              ? 'examInformation'
              : 'eventInformation',
          params: {
            id: this.notification.eventId,
            pagination: 1,
          },
        },
      };
    },
  },

  methods: {
    onClickNotification() {
      this.$router.push(this.routers[this.notification.type]);
      if (!this.notification.isClick) {
        this.$emit('updateNotification', this.notification);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.notification-btn {
  width: 288px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
  border-radius: 4px;
  @media screen and (max-width: 768px) {
    width: 100%;
    border: 1px solid $gray-400;
    border-radius: 24px;
    box-shadow: none;
  }

  ::v-deep.dropdown-item {
    padding: 8px;
    display: flex;
    align-items: center;
    white-space: pre-wrap;
  }
  &:not(:last-child) {
    margin-bottom: 8px;
  }
}
</style>
